import { ReactNode } from 'react';

import {
  BrowserType,
  CONTENT_BROWSER_TYPE,
  CURRICULUM_BROWSER_TYPE,
  YEAR_BROWSER_TYPE,
} from 'approot/shared/browser-tabs/browser-types.constants';
import {
  ENGLISH,
  GEOGRAPHY,
  HISTORY,
  MATHS,
  NSWCurriculumVersions,
  NSW_CURRICULUM_VERSION_2012,
  NSW_CURRICULUM_VERSION_2015,
  NSW_CURRICULUM_VERSION_2017,
  NSW_CURRICULUM_VERSION_2022,
  NSW_CURRICULUM_VERSION_2024,
  SCIENCE_AND_TECHNOLOGY,
  Subject,
} from 'global/constants';
import {
  InquisitiveCurriculum,
  InquisitiveCurriculumVersions,
  InquisitiveSubject,
  InquisitiveYears,
} from 'global/graphql/scalars.type';
import { DropdownListItem, FilterSubject } from 'webclient.constants';

export const VIEW_UNITS = 'units';
export const VIEW_LESSONS = 'lessons';
export type ViewMode = typeof VIEW_UNITS | typeof VIEW_LESSONS;
export const VIEW_FIELD = 'viewField';
export const VIEW_KEY = 'view';

// NSW Curriculum Filter Configuration
// We expect more subjects to be added here
export const NSW_CURRICULUM_FILTER_ALLOWED_SUBJECTS = [
  GEOGRAPHY,
  HISTORY,
  SCIENCE_AND_TECHNOLOGY,
  ENGLISH,
  MATHS,
] as Subject[];

export const NSW_CURRICULUM_FILTER_ALLOWED_BROWSER_TYPES = [
  CONTENT_BROWSER_TYPE,
  YEAR_BROWSER_TYPE,
  CURRICULUM_BROWSER_TYPE,
] as BrowserType[];

/**
 * Maps subjects to their allowed NSW curriculum versions.
 * If a subject is not in the map, all NSW curriculum versions are allowed.
 */
export const NSW_CURRICULUM_VERSION_SUBJECT_MAP = {
  [GEOGRAPHY]: [NSW_CURRICULUM_VERSION_2015, NSW_CURRICULUM_VERSION_2024],
  [HISTORY]: [NSW_CURRICULUM_VERSION_2012, NSW_CURRICULUM_VERSION_2024],
  [SCIENCE_AND_TECHNOLOGY]: [
    NSW_CURRICULUM_VERSION_2017,
    NSW_CURRICULUM_VERSION_2024,
  ],
  [ENGLISH]: [NSW_CURRICULUM_VERSION_2012, NSW_CURRICULUM_VERSION_2022],
  [MATHS]: [NSW_CURRICULUM_VERSION_2012, NSW_CURRICULUM_VERSION_2022],
} as Record<Subject, NSWCurriculumVersions[]>;

export const FILTER_VARIANT_LEGACY = 'filter-variant-legacy';
export const FILTER_VARIANT_DRAWER_ONLY = 'filter-variant-drawer-only';

export type FilterVariant =
  | typeof FILTER_VARIANT_LEGACY
  | typeof FILTER_VARIANT_DRAWER_ONLY;

export type FiltersType = {
  years: InquisitiveYears[];
  curriculum: InquisitiveCurriculum[];
  curriculumVersion: InquisitiveCurriculumVersions[];
  subjects: FilterSubject[];
};

export type FilterContextProps = {
  variant: FilterVariant;
  year?: InquisitiveYears;
  curriculum?: InquisitiveCurriculum;
  children: ReactNode;
  browserType: BrowserType;
  customCurriculumOptions?: DropdownListItem<InquisitiveCurriculum>[];
  customYearOptions?: DropdownListItem<InquisitiveYears>[];
  subject?: InquisitiveSubject;
  dataEventCategory: string;
  onFilterChange?: () => void;
  viewMode?: ViewMode;
  filterLabelHugsDropdown?: boolean;
};

export const FILTER_DRAWER_ID = 'filter-drawer';
export const FILTER_QUICK_ID = 'quick-filter';

export const FILTER_DRAWER_FOOTER_HEIGHT = 64;
